<template>
    <div class="row">
        <div class="col-12 col-sm-8 m-sm-auto">
            <h5>Distribución de correspondencia</h5>
            <div class="receive-form">
                <div class="mail-types">
                    <div class="btn-group" role="group">
                        <button
                            class="btn btn-lg"
                            :class="{
                                'btn-success': _type.id == mail.type.id,
                                'btn-secondary': _type.id !== mail.type.id,
                            }"
                            v-for="_type in mailTypes"
                            @click="mail.type = _type"
                        >
                            <i
                                class="fa"
                                v-if="!!_type.fa_class"
                                :class="_type.fa_class"
                            ></i>
                            {{ _type.name }}
                        </button>
                    </div>
                </div>
                <span v-if="$v.mail.type.$error" class="field-error"
                    >Debe seleccionar un tipo de correspondencia</span
                >

                <div>
                    <app-form-select-input
                        label="Tipo de estructura"
                        :options="structureTypes"
                        @change="loadStructures"
                        :hasError="$v.structureTypeId.$error"
                        errorMessage="Debe seleccionar el tipo de estructura"
                        v-model="structureTypeId"
                    >
                    </app-form-select-input>
                </div>

                <div
                    class="alert alert-info"
                    v-if="!structures.length && !!structureTypeId"
                >
                    <h4>No hay estructuras registradas de este tipo</h4>
                </div>
                <div class="destination" v-if="!!structures.length">
                    <table class="table table-sm table-bordered">
                        <thead class="thead-orange">
                            <tr class="thead-orange">
                                <th>Tipo</th>
                                <th>Nombre</th>
                                <th>Teléfono</th>
                                <th>
                                    <div class="header-buttons">
                                        <button
                                            class="btn btn-link"
                                            @click="selectAll()"
                                        >
                                            <i
                                                class="fa fa-check-square-o fa-2x"
                                                aria-hidden="true"
                                            ></i>
                                            Todos
                                        </button>
                                        <button
                                            class="btn btn-link"
                                            @click="deselectAll()"
                                        >
                                            <i
                                                class="fa fa-square-o fa-2x"
                                                aria-hidden="true"
                                            ></i>
                                            Ninguno
                                        </button>
                                    </div>
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="structure in structures">
                                <td>{{ structure.structure_type.name }}</td>
                                <td>{{ structure.name }}</td>
                                <td>{{ structure.phone }}</td>
                                <td>
                                    <input
                                        type="checkbox"
                                        name=""
                                        id=""
                                        :value="structure.id"
                                        v-model="selectedStructures"
                                    />
                                </td>
                            </tr>
                        </tbody>
                    </table>
                    <span
                        v-if="$v.selectedStructures.$error"
                        class="field-error"
                        >Debe Seleccionar las estructuras</span
                    >
                </div>
                <hr />
                <div class="form-group">
                    <label for="notes">Escriba que correspondencia llego</label>
                    <textarea
                        name="notes"
                        id="notes"
                        cols="30"
                        rows="4"
                        class="form-control"
                        v-model="mail.notes"
                    ></textarea>
                    <span v-if="$v.mail.notes.$error" class="field-error"
                        >Debe Escribir que correspondencia llegó</span
                    >
                </div>
                <hr />
                <div class="text-right">
                    <button class="btn btn-secondary" @click="$router.go(-1)">
                        <i class="fa fa-times"></i> Cancelar
                    </button>
                    <button
                        class="btn btn-confirm"
                        @click="saveMails()"
                        :disabled="inProgress"
                    >
                        <i class="fa fa-check-square-o" aria-hidden="true"></i>
                        Recibir correspondencia
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import vigilanceRepository from '../../../../../repositories/vigilance.repository'
import Autocomplete from '../../../../UI/Controls/Autocomplete/Autocomplete.vue'
import FormSelectInput from '../../../../UI/Controls/Forms/FormSelectInput.vue'
import { required } from 'vuelidate/lib/validators'
import { mapActions, mapGetters } from 'vuex'

export default {
    components: {
        appAutocomplete: Autocomplete,
        appFormSelectInput: FormSelectInput,
    },
    data() {
        return {
            mail: {
                type: '',
                notes: '',
            },
            structures: [],
            selectedStructures: [],
            structureTypeId: '',
            checked: true,
        }
    },
    validations: {
        mail: {
            type: {
                required,
            },
            notes: {
                required,
            },
        },
        selectedStructures: {
            required,
        },
        structureTypeId: {
            required,
        },
    },
    watch: {
        client(val) {
            if (!val) return

            this.loadStructures()
        },
    },
    computed: {
        ...mapGetters(['structureTypes', 'mailTypes']),
    },
    methods: {
        ...mapActions(['receiveMail']),
        async loadStructures(type) {
            const { data } = await repo.get('structures', {
                type,
                client: this.client.id,
            })

            this.structures = data
            this.selectedStructures = data.map(item => item.id)
        },
        selectAll() {
            this.selectedStructures = []
            this.structures.map(item => this.selectedStructures.push(item.id))
        },
        deselectAll() {
            this.selectedStructures = []
        },
        saveMails() {
            this.$v.$touch()
            if (this.$v.$invalid)
                return toastr.warning(
                    'Diligenciar correctamente todos los campos'
                )

            const payload = {
                selectedStructures: this.selectedStructures,
                typeId: this.mail.type.id,
                notes: this.mail.notes,
                clientId: this.client.id,
                userId: this.user.id,
            }
            const vr = Object.assign({}, vigilanceRepository)
            vr.distributionMail(payload)
                .then(data => {
                    this.$v.$reset()
                    toastr.success(data.msg)
                    this.cleanFields()
                })
                .catch(error => {
                    toastr.error(
                        'Ocurrió un error al ingresar las correspondencias'
                    )
                })
        },
        cleanFields() {
            Object.keys(this.mail).map(key => (this.mail[key] = ''))
            this.selectedStructures = []
            this.structureTypeId = ''
            this.structures = []
            this.$v.$reset()
        },
    },
    created() {
        this.cleanFields()
        this.load('mailTypes')
        this.load('structureTypes')
    },
}
</script>
